import { border } from "./border.theme";
import { breakpoints } from "./breakpoints.theme";
import { color } from "./color.thems";
import { font } from "./font.theme";
import { shadow } from "./shadow.theme";

export const Theme = {
  color,
  font,
  border,
  breakpoints,
  shadow,
};
